var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 sm:px-5 lg:px-1 max-w-6xl md:w-full md:mx-auto"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }